"use client";

import { Minus, Plus } from "lucide-react";
import { useState } from "react";
import type { FaqItem } from "@/components/sections/FaqSection";

export type FaqAccordionListProps = {
  items: FaqItem[];
  defaultOpenIndex?: number;
  className?: string;
};

export function FaqAccordionList({
  items,
  defaultOpenIndex = 0,
  className,
}: FaqAccordionListProps) {
  const [openIndex, setOpenIndex] = useState(defaultOpenIndex);

  return (
    <div className={["space-y-3", className].filter(Boolean).join(" ")}>
      {items.map((item, index) => {
        const isOpen = openIndex === index;

        return (
          <article key={item.question} className="overflow-hidden">
            <button
              type="button"
              aria-expanded={isOpen}
              onClick={() =>
                setOpenIndex((prev) => (prev === index ? -1 : index))
              }
              className={[
                "flex w-full items-center justify-between gap-4 rounded-[2px] border px-4 py-3 text-left transition-colors duration-300 sm:px-5",
                isOpen
                  ? "border-[#b46c29] bg-[#b46c29] text-white"
                  : "border-[#d9b388] bg-[#f3f0ef] text-[#5a5a5a] hover:border-[#b46c29]",
              ].join(" ")}
            >
              <span className="font-heading text-[13px] font-semibold leading-tight sm:text-[15px]">
                {item.question}
              </span>
              {isOpen ? (
                <Minus className="h-4 w-4 shrink-0" aria-hidden="true" />
              ) : (
                <Plus
                  className="h-4 w-4 shrink-0 text-[#b46c29]"
                  aria-hidden="true"
                />
              )}
            </button>

            <div
              className={[
                "grid transition-[grid-template-rows,opacity] duration-300 ease-out",
                isOpen
                  ? "grid-rows-[1fr] opacity-100"
                  : "grid-rows-[0fr] opacity-0",
              ].join(" ")}
            >
              <div className="overflow-hidden">
                <div className="border-x border-b border-[#d9b388] bg-white px-4 py-4 text-sm leading-[1.85] text-[#505050] sm:px-5 sm:text-[15px]">
                  {item.answer}
                </div>
              </div>
            </div>
          </article>
        );
      })}
    </div>
  );
}
